import * as z from 'zod';

export const SizeSchema = z.object({
    idAttribute: z.number(),
    price: z.number(),
    name: z.string(),
    width: z.number(),
    height: z.number(),
    position: z.number(),
});

export const FabricSchema = z.object({
    idAttribute: z.number(),
    price: z.number(),
    name: z.string(),
    description: z.string(),
    default: z.boolean(),
});

export const DiscountSchema = z.object({
    idSpecificPrice: z.number(),
    fromQuantity: z.number(),
    reduction: z.number(),
    reductionType: z.string(),
});

export const CurrencySchema = z.object({
    id: z.number(),
    isoCode: z.string(),
    prefix: z.string(),
    suffix: z.string(),
    conversionRate: z.number(),
    decimals: z.number(),
});

export const ProductSchema = z.object({
    idProduct: z.number(),
    idGarment: z.number(),
    name: z.string(),
    price: z.number(),
    priceTaxIncl: z.number(),
    tax: z.number(),
    sizes: z.array(SizeSchema),
    fabrics: z.array(FabricSchema),
    discounts: z.array(DiscountSchema),
    currency: CurrencySchema,
    language: z.string(),
});

export type Product = z.infer<typeof ProductSchema>;
export type Size = z.infer<typeof SizeSchema>;
export type Fabric = z.infer<typeof FabricSchema>;
export type Currency = z.infer<typeof CurrencySchema>;
